import { jsx as r, jsxs as c } from "react/jsx-runtime";
import "react";
var a = (l) => /* @__PURE__ */ c("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 36 36",
  ...l,
  children: [/* @__PURE__ */ r("path", {
    fill: "currentColor",
    d: "M17.998 26.9c.904 0 1.637-.746 1.637-1.667 0-.92-.733-1.667-1.637-1.667s-1.637.747-1.637 1.667.733 1.667 1.637 1.667Zm-.164-14.667c-1.015.1-1.768 1-1.67 2.034l.622 6.833c.066.6.524 1.067 1.113 1.133.688.067 1.277-.433 1.343-1.133l.622-6.833v-.334c-.13-1.033-1.015-1.8-2.03-1.7Z"
  }), /* @__PURE__ */ r("path", {
    fill: "currentColor",
    d: "M32.896 25 21.894 6.267A4.451 4.451 0 0 0 17.998 4 4.451 4.451 0 0 0 14.1 6.267L3.1 25c-.852 1.467-.885 3.2-.066 4.667C3.853 31.133 5.326 32 6.996 32h21.971c1.67 0 3.143-.866 3.962-2.333A4.582 4.582 0 0 0 32.896 25Zm-2.26 3.334A1.85 1.85 0 0 1 29 29.3H6.996c-.688 0-1.31-.367-1.637-.966a1.942 1.942 0 0 1 .033-1.934L16.36 7.633c.36-.6.95-.933 1.637-.933a1.86 1.86 0 0 1 1.637.933l11.002 18.734a2.091 2.091 0 0 1 0 1.966Z"
  })]
});
export {
  a as default
};
